@let hasFundValuation = ((fundValuation$ | async)?.data?.id !== undefined);
@let hasFundReport = ((fundReport$ | async)?.fundReport?.data?.id !== undefined);
@let isUndrawnComplete = (isUndrawnComplete$ | async);
@if (isLoading$ | async) {
    <valumize-loading-spinner></valumize-loading-spinner>
}
<mat-sidenav-container>
    <mat-sidenav #sidenav class="mat-elevation-z8" mode="side" opened>
        @let isMaster = (sourceDataset$ | async) === 'master';
        @let fundValuation = fundValuation$ | async;
        @if (sidenav.opened) {
            <div class="top-right-nav-toggle">
                <button (click)="sidenav.toggle()" color="primary" mat-icon-button>
                    <mat-icon>close</mat-icon>
                </button>
            </div>
        }
        <div>
            @if (reportDate$ | async; as reportDate) {
                <div class="sidenav-info report-date">
                    @if (!!reportDate.date) {
                        <div>
                            <div style="display: flex; align-items: center">
                                <div>
                                    <label data-test="report-date-label">Report Date</label>
                                    <p [class.highlight]="highlightFundReportDate" data-test="report-date">
                                        {{ reportDate | traceableFormat }}
                                    </p>
                                </div>
                                <button
                                    (click)="openNewFundReportDialog()"
                                    color="primary"
                                    data-test="edit-report-date-button"
                                    mat-icon-button>
                                    <mat-icon>manage_history</mat-icon>
                                </button>
                            </div>
                            @if (isMaster) {
                                @if (fundValuation) {
                                    @if (!!fundValuation.data.closingDate.date) {
                                        <div>
                                            @let vt = fundValuation.data.valuationType.code;
                                            <mat-chip
                                                [disableRipple]="true"
                                                [ngClass]="{
                                                    'vt-topdown': vt === 'TOP_DOWN_VALUATION',
                                                    'vt-bottomup': vt === 'BOTTOM_UP_VALUATION'
                                                }">
                                                {{ vt | codeFormat: codeTableFundValuationType | async }}
                                            </mat-chip>

                                            <div style="display: flex; align-items: center">
                                                <div>
                                                    <label data-test="closing-date-label">Closing Date</label>
                                                    <p [class.highlight]="highlightFundClosingDate" data-test="closing-date">
                                                        {{ fundValuation.data.closingDate | traceableFormat }}
                                                    </p>
                                                </div>
                                                <button
                                                    (click)="openNewFundValuationDialog()"
                                                    color="primary"
                                                    data-test="edit-report-date-button"
                                                    mat-icon-button>
                                                    <mat-icon>manage_history</mat-icon>
                                                </button>
                                            </div>

                                            <div class="description-row">
                                                <div>
                                                    <label>Description</label>
                                                    <p class="ellipsis" [title]="fundValuation.data.description | traceableFormat">
                                                        {{ fundValuation.data.description | traceableFormat }}
                                                    </p>
                                                </div>
                                                <button
                                                    (click)="openEditFundValuationDescriptionDialog()"
                                                    color="primary"
                                                    data-test="edit-fund-valuation-description-button"
                                                    mat-icon-button>
                                                    <mat-icon>edit</mat-icon>
                                                </button>
                                            </div>
                                        </div>
                                    } @else {
                                        <div style="display: flex">
                                            <button
                                                (click)="openNewFundValuationDialog()"
                                                [disabled]="(isEditDisabled$ | async)!"
                                                color="primary"
                                                data-test="create-or-select-fund-valuation"
                                                mat-stroked-button>
                                                <mat-icon>add</mat-icon>
                                                Fund Valuation
                                            </button>
                                        </div>
                                    }
                                }
                            }
                        </div>
                    } @else {
                        <div>
                            <button
                                (click)="openNewFundReportDialog()"
                                [disabled]="(isEditDisabled$ | async)!"
                                color="primary"
                                data-test="create-or-select-fund-report"
                                mat-stroked-button>
                                <mat-icon>add</mat-icon>
                                Fund Report
                            </button>
                        </div>
                    }
                </div>
            }
            <mat-divider></mat-divider>
            <div class="sidenav-info">
                @let generalPartner = (selectedGeneralPartner$ | async);
                @if (!!generalPartner && generalPartner.id) {
                    <div style="display: flex; align-items: center" class="general-partner">
                        <div>
                            <label data-test="general-partner-label">General Partner</label>
                            <a [routerLink]="'../../gp/'+generalPartner.id" [title]="generalPartner.name | traceableFormat" style="text-decoration: none;">
                                <p class="ellipsis" data-test="general-partner">
                                    @if (generalPartner.isArchived.value) {
                                        <mat-icon class="archived-icon" style="margin-right: 4px;">inventory_2</mat-icon>
                                    }
                                    {{ generalPartner.name | traceableFormat }}
                                </p>
                            </a>
                        </div>
                        <button
                            (click)="openNewGeneralPartnerDialog()"
                            [disabled]="(isEditDisabled$ | async)!"
                            color="primary"
                            data-test="edit-general-partner-button"
                            mat-icon-button>
                            <mat-icon>manage_history</mat-icon>
                        </button>
                    </div>
                    <div>
                        <label data-test="general-partner-quality-label">General Partner Quality</label>
                        <p data-test="general-partner-quality">{{ generalPartner?.quality?.code | codeFormat: codeTableGpQuality | async }}</p>
                    </div>
                } @else {
                    <button (click)="openNewGeneralPartnerDialog()"
                            [disabled]="(isEditDisabled$ | async)!"
                            class="general-partner"
                            color="primary"
                            data-test="create-or-select-general-partner"
                            mat-stroked-button>
                        <mat-icon>add</mat-icon>
                        General Partner
                    </button>
                }
            </div>
            <mat-divider></mat-divider>
            @if (!isMaster) {
                <div class="sidenav-info">
                    <h3>Merge Targets</h3>
                    <div class="label-search">
                        <label>Selected Fund</label>
                        <button (click)="displaySearch()"
                                color="primary"
                                data-test="search-merge-target-button"
                                mat-icon-button>
                            <mat-icon>search</mat-icon>
                        </button>
                    </div>
                    @if (searchEnabled) {
                        <valumize-search
                            (searchResultSelected)="selectFundMergeTarget($event)"
                            [searchCategories]="['funds']"
                            [showSearchIcon]="false"
                            [targetSearch]="true">
                        </valumize-search>
                    }
                    @if (baselineFund$ | async; as baselineFund) {
                        <div class="selected-target">
                            <p class="selected-target-value">{{ baselineFund.data.name | traceableFormat }}</p>
                            @if (baselineFund.data.id) {
                                <button (click)="deselectFundMergeTarget()"
                                        color="primary"
                                        data-test="cancel-button"
                                        mat-icon-button>
                                    <mat-icon>cancel</mat-icon>
                                </button>
                            }
                        </div>
                        @if (baselineFund.data.id) {
                            <label>Selected Fund Report</label>
                            @if (baselineFundReport$ | async; as baselineFundReport) {
                                <div class="selected-target">
                                    <p class="selected-target-value">{{ baselineFundReport.data.reportDate | traceableFormat }}</p>
                                </div>
                            }
                        }
                    }
                    <button mat-stroked-button color="primary" (click)="openMergePreview()" data-test="merge-preview-button">
                        <mat-icon>preview</mat-icon>
                        Merge Preview
                    </button>
                </div>
                <mat-divider></mat-divider>
            }
            <mat-action-list>
                <a (click)="scrollToComponent('fund-details')" data-test="fund-details-nav-item">
                    <mat-list-item>Fund Details</mat-list-item>
                </a>
                <a (click)="scrollToComponent('fund-report-details')" data-test="fund-report-details-nav-item">
                    <mat-list-item>Fund Report Details</mat-list-item>
                </a>
                @if (isMaster && hasFundValuation) {


                    <a (click)="scrollToComponent('partnership-investments')" data-test="partnership-investments-nav-item">
                        <mat-list-item>Partnership Investments</mat-list-item>
                    </a>

                    @if (fundValuation) {
                        @let vt = fundValuation?.data?.valuationType?.code;
                        @let isTopDown = vt === fundValuationTypeEnum.TopDownValuation;
                        @if (isTopDown) {
                            <a (click)="scrollToComponent('top-down-valuation')" data-test="top-down-valuation-nav-item">
                                <mat-list-item>Top Down</mat-list-item>
                            </a>
                            <a (click)="scrollToComponent('top-down-p-inv-card')" data-test="partnership-investments-nav-item">
                                <mat-list-item>Partnership Investments</mat-list-item>
                            </a>
                        }

                    }
                } @else {
                    <a (click)="scrollToComponent('partnership-investments')" data-test="partnership-investments-nav-item">
                        <mat-list-item>Partnership Investments</mat-list-item>
                    </a>
                }
                @if (isMaster && hasFundValuation) {
                    <a (click)="scrollToComponent('undrawn-valuation')" data-test="undrawn-valuation-nav-item">
                        <mat-list-item>Undrawn Valuation</mat-list-item>
                    </a>
                    <a (click)="scrollToComponent('return-summary')" data-test="return-summary-nav-item">
                        <mat-list-item>Return Summary</mat-list-item>
                    </a>
                }
                @if (hasFundValuation) {
                    <a (click)="scrollToComponent('seller-position')" data-test="seller-position-nav-item">
                        <mat-list-item>Seller Position</mat-list-item>
                    </a>
                }
                @if (isMaster && hasFundReport) {
                    <a (click)="scrollToComponent('treemap-actual')" data-test="treemap-actual-nav-item">
                        <mat-list-item>Treemap Actual</mat-list-item>
                    </a>
                }
                @if (isMaster && hasFundValuation && isUndrawnComplete) {
                    <a (click)="scrollToComponent('fund-cashflows')" data-test="fund-cashflows-nav-item">
                        <mat-list-item>Fund Cashflows</mat-list-item>
                    </a>
                }
                <a (click)="scrollToComponent('documents')" data-test="documents-nav-item">
                    <mat-list-item>Documents</mat-list-item>
                </a>
            </mat-action-list>
        </div>
    </mat-sidenav>
    <mat-sidenav-content>
        @if (isArchived$ | async; as isArchived) {
            @if (!sidenav.opened) {
                <div class="top-left-nav-toggle">
                    <button (click)="sidenav.toggle()" color="primary" mat-icon-button>
                        <mat-icon>menu</mat-icon>
                    </button>
                </div>
            }

            @if (fundName$ | async; as fundName) {
                <div>
                    <div class="breadcrumb-container">
                        <label class="breadcrumb" data-test="breadcrumb">
                            @if (deal$ | async; as deal) {
                                @if (!!deal.id) {
                                    <mat-icon>work_history</mat-icon>
                                    <a [routerLink]="'../../deals/' + deal.id">{{ deal.projectName | traceableFormat }}</a>
                                    <mat-icon>chevron_right</mat-icon>
                                }
                            }
                            <mat-icon>domain</mat-icon>
                            {{ fundName.name | traceableFormat }}
                        </label>
                        @if (fundId) {
                            <valumize-fund-ai-setup-status-chip [fundId]="fundId"></valumize-fund-ai-setup-status-chip>
                            @if (fundValuationId) {
                                <valumize-algorithmic-dmv-status-chip
                                    [fundId]="fundId"
                                    [fundValuationId]="fundValuationId"></valumize-algorithmic-dmv-status-chip>
                            }
                        }
                        @if (isMaster) {
                            <div class="detail-page-top-right-menu">
                                <button mat-icon-button class="menu-button"
                                        [matMenuTriggerFor]="fundMenu"
                                        aria-label="More options"
                                        (click)="onFundMenuButtonClick($event)">
                                    <mat-icon>more_vert</mat-icon>
                                </button>
                                <mat-menu #fundMenu="matMenu">
                                    @if (fundValuationId) {
                                        <button mat-menu-item (click)="openPatternAssignments()">
                                            <mat-icon>account_tree</mat-icon>
                                            <span>Pattern Settings</span>
                                        </button>
                                    }
                                    <button mat-menu-item (click)="openDocumentGeneratorDialog()">
                                        <mat-icon>article_shortcut</mat-icon>
                                        <span>Generate Document</span>
                                    </button>
                                    <button mat-menu-item (click)="openAiSetupDialog()">
                                        <mat-icon>auto_awesome</mat-icon>
                                        <span>AI Setup Fund</span>
                                    </button>
                                    <button mat-menu-item (click)="openAlgorithmicDmvDialog()">
                                        <mat-icon>functions</mat-icon>
                                        <span>Run Algorithmic DMV</span>
                                    </button>
                                    <button mat-menu-item (click)="openArchiveConfirmation(!isArchived.value)">
                                        <mat-icon>{{ isArchived.value ? 'unarchive' : 'archive' }}</mat-icon>
                                        <span>{{ isArchived.value ? 'Unarchive' : 'Archive' }}</span>
                                    </button>
                                </mat-menu>
                            </div>
                        }
                    </div>
                    <div class="page-content">
                        @if ((fundError$ | async); as fundError) {
                            <valumize-info-panel [appearance]="'ERROR'" [message]="fundError"></valumize-info-panel>
                        }
                        @if (!!fundValuation && fundValuation.status === 'ERROR') {
                            <valumize-info-panel [appearance]="'ERROR'" [message]="fundValuation.errorMessage"></valumize-info-panel>
                        }
                        @if ((fundReport$ | async)?.fundReport; as fundReport) {
                            @if (fundReport.status === 'ERROR') {
                                <valumize-info-panel [appearance]="'ERROR'" [message]="fundReport.errorMessage"></valumize-info-panel>
                            }
                        }
                        @if ((mergeError$ | async); as mergeError) {
                            @if (mergeError.statusCode) {
                                <valumize-info-panel [appearance]="'ERROR'" [message]="mergeError.errorMessage"></valumize-info-panel>
                            }
                        }
                        <form [formGroup]="nameForm">
                            <div class="detail-page-header">
                                <div>
                                    @if (!fundNameIsEditable) {
                                        <h1 data-test="fund-name" title="Last modified: {{fundName.name.modDate | timestamp}}">
                                            {{ fundName.name | traceableFormat }}
                                        </h1>
                                    }
                                    @if (fundNameIsEditable) {
                                        <mat-form-field appearance="fill">
                                            <input data-test="fund-name-input"
                                                   formControlName="fundName"
                                                   matInput
                                                   placeholder="Fund Name">
                                        </mat-form-field>
                                    }
                                </div>
                                <div>
                                    @if (!fundNameIsEditable) {
                                        <button
                                            (click)="editFundName()"
                                            [disabled]="(isEditDisabled$ | async)!"
                                            color="primary"
                                            data-test="edit-button"
                                            mat-icon-button>
                                            <mat-icon>edit</mat-icon>
                                        </button>
                                    }
                                    @if (fundNameIsEditable) {
                                        <button
                                            (click)="saveFundName()"
                                            [disabled]="nameForm.invalid"
                                            color="primary"
                                            data-test="save-button"
                                            mat-icon-button>
                                            <mat-icon>save</mat-icon>
                                        </button>
                                    }
                                    @if (fundNameIsEditable) {
                                        <button
                                            (click)="cancelFundName()"
                                            color="primary"
                                            data-test="cancel-button"
                                            mat-icon-button>
                                            <mat-icon>cancel</mat-icon>
                                        </button>
                                    }
                                    @if (isArchived.value) {
                                        <mat-chip
                                            class="archived"
                                            [disableRipple]="true"
                                            matTooltip="{{isArchived.modDate | date}}">
                                            <mat-icon matChipAvatar>inventory_2</mat-icon>
                                            <span>Archived</span>
                                        </mat-chip>
                                    }
                                </div>
                                @let fundReportDateValue = (reportDate$ | async) ?? undefined;
                                @let selectedFundValuation = (fundValuation$ | async)?.data;
                                @let routeValuation = selectedFundValuation?.id === fundValuationId ? selectedFundValuation : undefined;
                                <valumize-favorite-star
                                    [favType]="'FUND'"
                                    [label]="fundName.name.text ?? ''"
                                    [report]="fundReportDateValue?.date ? (fundReportDateValue | traceableFormat) : undefined"
                                    [closingDate]="routeValuation?.closingDate?.date ? (routeValuation?.closingDate | traceableFormat) : undefined"
                                    [valuation]="routeValuation?.description?.text?.trim() || undefined">
                                </valumize-favorite-star>
                            </div>
                        </form>
                        <div class="component-wrapper">
                            <valumize-fund-details class="component-wide" id="fund-details"></valumize-fund-details>
                            <valumize-fund-report-details class="component-narrow" id="fund-report-details"></valumize-fund-report-details>
                        </div>
                        @if (hasFundValuation) {
                            @let vt = fundValuation?.data?.valuationType?.code;
                            @let isTopDown = vt === fundValuationTypeEnum.TopDownValuation;

                            @if (isMaster && isTopDown) {
                                <mat-card class="detail-card-no-padding" id="top-down-p-inv-card">
                                    <mat-card-content class="detail-card-content-no-padding">
                                        <mat-tab-group>
                                            <mat-tab label="Top-Down Valuation">
                                                <valumize-fund-top-down-valuation id="top-down-valuation"></valumize-fund-top-down-valuation>
                                            </mat-tab>
                                            <mat-tab label="Partnership Investments">
                                                <valumize-fund-partnership-investments id="partnership-investments"></valumize-fund-partnership-investments>
                                            </mat-tab>
                                        </mat-tab-group>
                                    </mat-card-content>
                                </mat-card>
                            } @else {
                                <valumize-fund-partnership-investments id="partnership-investments"></valumize-fund-partnership-investments>
                            }
                        } @else {
                            <!-- No valuation available: still show Partnership -->
                            <valumize-fund-partnership-investments id="partnership-investments"></valumize-fund-partnership-investments>
                        }
                        <div>
                            @if (isMaster && hasFundValuation) {
                                <valumize-fund-undrawn-valuation id="undrawn-valuation"></valumize-fund-undrawn-valuation>

                                <valumize-fund-return-summary id="return-summary"></valumize-fund-return-summary>
                            }
                        </div>
                        @if (hasFundValuation) {
                            <valumize-fund-seller-position class="component" id="seller-position"></valumize-fund-seller-position>
                        }
                        @if (isMaster && hasFundReport) {
                            <valumize-fund-treemap-actual class="component" id="treemap-actual"></valumize-fund-treemap-actual>
                        }
                        @if (isMaster && hasFundValuation && isUndrawnComplete) {
                            <div>
                                <valumize-fund-cashflows-graph></valumize-fund-cashflows-graph>
                                <valumize-fund-cashflows id="fund-cashflows"></valumize-fund-cashflows>
                            </div>
                        }
                        <valumize-document id="documents" [context]="'/portfolio/funds/' + fundId + '/'"></valumize-document>
                        <br/>
                        <br/>
                        <br/>
                    </div>
                </div>
            }
        }
    </mat-sidenav-content>
</mat-sidenav-container>

